import iconDeleteQuery from '@/core/assets/images/icons/delete.svg';
import arrowDownIcon from '@/core/assets/images/icons/arrow-down.svg';
import getScreenInfo from '@/core/helpers/get-screen-info.js';

export default function (images) {
    const shDom = document.querySelector('searchbooster-search-popup');
    const search = shDom.shadowRoot.querySelector('.l-ss-c-search-popup-wrapper');
    const modal = document.createElement('div');
    modal.classList.add('l-ss-c-offer-thumbnail-modal-wrapper');
    if (getScreenInfo().isMobile) {
        modal.classList.add('ls-ss-c-is-mobile');
    }

    modal.innerHTML = '<div class="l-ss-c-offer-thumbnail-modal">' +
    '<div class="l-ss-c-offer-close-modal">' +
        '<i class="l-ss-c-search-input-icon l-ss-c-search-input-icon-close">' + iconDeleteQuery + '</i>' +
    '</div>' +
    '<div class="l-ss-c-offer-thumbnail-items-wrapper">' +
        images.map(element => { return `<div class="l-ss-c-offer-thumbnail-item"><img src="${element}"></img></div>`; } ).join('') +
    '</div>' +
    '<div class="l-ss-c-offer-thumbnail-modal-button-left">' +
        '<div class="l-ss-c-offer-thumbnails-navigation"><button data-v-action="nextImage" class="l-ss-c-offer-thumbnails-navigation-left"><i class="icon-white">' + arrowDownIcon + '</i></button></div>' +
    '</div>' +
    '<div class="l-ss-c-offer-thumbnail-modal-button-right">' +
        '<div class="l-ss-c-offer-thumbnails-navigation"><button data-v-action="nextImage" class="l-ss-c-offer-thumbnails-navigation-right"><i class="icon-white">' + arrowDownIcon + '</i></button></div>' +
    '</div>' +
    '</div>';
    search.appendChild(modal);
    const closeModal = shDom.shadowRoot.querySelector('.l-ss-c-offer-close-modal');
    const buttonLeft = shDom.shadowRoot.querySelector('.l-ss-c-offer-thumbnail-modal-button-left');
    const buttonRight = shDom.shadowRoot.querySelector('.l-ss-c-offer-thumbnail-modal-button-right');
    if (images.length < 2) {
        buttonLeft.remove();
        buttonRight.remove();
    }
    const slides = shDom.shadowRoot.querySelectorAll('.l-ss-c-offer-thumbnail-item');
    slides[0].classList.add('l-ss-c-offer-thumbnail-item-block');
    let i = 0;
    closeModal.onclick = () => {
        modal.remove();
    };
    buttonLeft.onclick = () => {
        if (i > 0) {
            slides[i].classList.remove('l-ss-c-offer-thumbnail-item-block');
            i--;
            slides[i].classList.add('l-ss-c-offer-thumbnail-item-block');
        } else {
            i = slides.length - 1;
            slides[0].classList.remove('l-ss-c-offer-thumbnail-item-block');
            slides[i].classList.add('l-ss-c-offer-thumbnail-item-block');
        }
    };
    buttonRight.onclick = () => {
        ++i;
        if (i >= slides.length) {
            slides[i - 1].classList.remove('l-ss-c-offer-thumbnail-item-block');
            i = 0;
            slides[i].classList.add('l-ss-c-offer-thumbnail-item-block');
        } else {
            slides[i - 1].classList.remove('l-ss-c-offer-thumbnail-item-block');
            slides[i].classList.add('l-ss-c-offer-thumbnail-item-block');
        }
    };
}